export default __webpack_public_path__ + "static/media/insta4.2f3d934b.jpg";